import { render, staticRenderFns } from "./ad_data.vue?vue&type=template&id=518b8a62&scoped=true&"
import script from "./ad_data.vue?vue&type=script&lang=js&"
export * from "./ad_data.vue?vue&type=script&lang=js&"
import style0 from "./ad_data.vue?vue&type=style&index=0&id=518b8a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b8a62",
  null
  
)

export default component.exports